import { styled } from "@mui/material";

export const ContainerForms = styled("div")(() => ({
  width: "40.5%",
  display: "flex",
  flexDirection: "column",
  gap: "3rem",
}));

export const ContainerObjectToMove = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
}));

export const ButtonStyle = styled("div")(() => ({
  "& button": {
    width: "9.25rem !important",
    padding: "0 !important",
    fontSize: "0.75rem !important",
    fontStyle: "Inter !important",
  },
}));

export const ContainerWhereToMove = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
}));

export const ContainerButtons = styled("div")(() => ({
  display: "flex",
  gap: "1.5rem",
  justifyContent: "flex-end",
}));

export const SelectContainers = styled("div")(() => ({
  width: "auto",
  "& .MuiFormControl-root > span": {
    marginBottom: "0.625rem !important",
  },
}));

export const ConfirmationModalContent = styled("p")(() => ({
  fontFamily: "Inter",
  fontWeight: 400,
  fontSize: "1rem",
  lineHeight: "1.5rem",
  "& span": {
    fontWeight: 700,
  },
}));
